// extracted by mini-css-extract-plugin
module.exports = {"twoColumnMinWidth":"672px","threeColumnWithSidebarMinWidth":"1360px"};